/* eslint-disable @typescript-eslint/no-unused-vars */
import { api, showErrorNotification } from '@med-fe/util';
import { call } from 'redux-saga/effects';

export function* getHolidaysFullStartWorker(action?: any): Generator {
  try {
    const url = `/holidays/full`;
    const data: any = yield call(api.get, url, true, true);

    if (action?.payload?.onSuccess) {
      yield call(action.payload.onSuccess, data);
    }

    return data;
  } catch (e: any) {
    if (action?.payload?.onError) {
      yield call(action.payload.onError, e);
    } else {
      showErrorNotification();
    }
    return null;
  }
}

export function fetchHolidaysFull(): Promise<any> {
  const url = `/holidays/full`;
  return api.get(url, true, true);
}

export default getHolidaysFullStartWorker;
